import { render, staticRenderFns } from "./InfoPointProducts.vue?vue&type=template&id=49c6406c&"
import script from "./InfoPointProducts.vue?vue&type=script&lang=js&"
export * from "./InfoPointProducts.vue?vue&type=script&lang=js&"
import style0 from "./InfoPointProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports